import React, { FunctionComponent, useContext, useEffect, useState } from 'react';

import { Routes } from '../../../constants/Routes';

import { ListModel } from '../../../services/content/list/models/ListModel';
import { ImageModel } from '../../../services/content/image/models/ImageModel';

import { ArticleModel } from '../../../services/content/article/models/ArticleModel';
import { SectionSecondaryContent } from '../SectionSecondaryContent';
import { SectionsDivider } from '../SectionsDivider';
import { getDividerTitle } from '../Section.helper';
import { CategoryModel } from '../../../services/content/category/models/CategoryModel';
import { SectionContext } from '../../../contexts/SectionContext';
import { getCategoryBySlugFromProxy } from '../../../services/content/category/Category';
import styles from '../../../styles/CulinaryFootball.module.scss';
import { ImageAsync } from '../../Image/ImageAsync';
import S365Picture from '../../Image/S365Picture';

const sponsorsList = [
    { imgSrc: '/culinaryFootball/sofia-mel-logo.png', href: 'https://culinary.woman.bg/', width: 115, height: 80 },
    { imgSrc: '/culinaryFootball/monini-logo.png', href: 'https://culinary.woman.bg/', width: 100, height: 71 },
    { imgSrc: '/culinaryFootball/BILLA-Logo.png', href: 'https://culinary.woman.bg/', width: 100, height: 29 },
    { imgSrc: '/culinaryFootball/President-logo.png', href: 'https://culinary.woman.bg/', width: 100, height: 55 },
];

type Props = {
    section: ListModel | null | undefined;
};

export const CulinaryFootball: FunctionComponent<Props> = ({ section }) => {

    if (section) {
        const dividerTitle = getDividerTitle(section);
        const sectionItems = section.items;
        const categoryImageMainMedia = section?.configuration?.category?.mainMedia[0] ?? null;

        return (
            <div className={`container mb-0 mb-md-5`}>
                <SectionsDivider
                    title={dividerTitle}
                    display={true}
                    imageComponent={
                        <CategoryImage imageUrl={(categoryImageMainMedia as ImageModel)?.urls?.uploaded?.original} />
                    }
                    link={'https://culinary.woman.bg'}
                />
                <div>
                <div className={`row px-0 mx-0 justify-content-between`}>
                    {sectionItems.map((content, idx) => {
                        content = content as ArticleModel;
                        return (
                            <SectionSecondaryContent
                                key={`content-key-${content?.id}`}
                                className='col-12 col-md-3 mb-md-3'
                                lazyLoadImage={false}
                                content={content}
                                category={content.category}
                            />
                        );
                    })}
                </div>
                <div className={`${styles.footer}`}>
                    <h4>Със съдействието на:</h4>
                    <div className={`${styles.sponsorList}`}>
                        {sponsorsList.map((sponsor) => (
                            <a key={sponsor.imgSrc} href={sponsor.href} target='_blank'>
                                <img src={sponsor.imgSrc} width={sponsor.width} height={sponsor.height} alt='' />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            </div>
        );
    }

    return null;
};

const CategoryImage: FunctionComponent<{ imageUrl?: string }> = ({ imageUrl }) => {
    if (!imageUrl) {
        return <></>;
    }

    return (
        <div className={styles.sectionImageContainer}>
            <S365Picture url={imageUrl + `?operations=autocrop(120:50)`} alt={''} isPriority={false} className='normalize-nextjs-image' />
        </div>
    );
};
